import React, {useState} from 'react';
import {Modal, Platform, ScrollView, Share, Text, View} from 'react-native';
import Button from '../../../../components/Button';
import Div from '../../../../lib/Div';
import MainStyle from '../../../../../MainStyle';
import {colors} from '../../../../assets/styles/colors';
import * as Clipboard from "expo-clipboard";
import {isFullSwing} from "../../../../constants";
import P from "../../../../lib/P";

type Props = { code: string, onClose: () => void };

const YourFriendChallengeCodeForm = (props: Props) => {
  const {code} = props;
  const [active, setActive] = useState(false);

  const handleShare = async () => {
    try {
      const message = "I’m inviting you to a golf challenge!\n\n";
      const link = Platform.OS === 'web' ? `${window.location.origin}/play-with-friends?code=${code}` : 'https://short.link/to/tournament';
      const fullMessage = `${message}Click on this link to join: ${link}`;

      setActive(true);
      await Clipboard.setStringAsync(fullMessage);
      await Share.share({message: fullMessage});

    } catch (error) {
      console.error("Error sharing:", error);
    }
  };

  return (
    <Modal animationType="fade" transparent visible={!!code} statusBarTranslucent={false} hardwareAccelerated={false}
           onRequestClose={props.onClose}>
      <View style={[MainStyle.fix_gradient_and_modal_error_in_landscape, MainStyle.flex1, MainStyle.bg_filter_modal]}>
        <ScrollView contentContainerStyle={MainStyle.flex1}>
          <View style={[MainStyle.min_h_full, MainStyle.a_i_c, MainStyle.j_c_c]}>
            <Div w={390} rounded={20} borderWidth={1} borderColor={colors.settings_border} overflow="hidden"
                 bg={isFullSwing ? '#131314' : colors.settings_bg} py={isFullSwing ? 0 : 43} alignItems="center">
              <P fw="500" fs={26} lh={isFullSwing ? 48 : 26} mb={isFullSwing ? 40 : 38}
                 bg={isFullSwing ? '#252526' : undefined} w="100%" ta="center">
                Challenge Code
              </P>

              <Text style={[MainStyle.c_white, MainStyle.Barlow500, MainStyle.f_s_22, MainStyle.m_b_14]}>
                Your Friend Challenge Code is:
              </Text>

              <Text style={styles.subtitle}>{code}</Text>

              <Button
                text="Let’s Go!" w={309} fontWeight="600" mb={13} onPress={props.onClose}
                color={isFullSwing ? 'white' : undefined} radius={isFullSwing ? 4 : undefined}
                bg={isFullSwing ? '#3369FF' : undefined}
              />

              <Button
                text="Share" w={309} fontWeight="600" mb={13} onPress={handleShare} radius={isFullSwing ? 4 : undefined}
                bg={active ? 'transparent' : isFullSwing ? '#3369FF' : ''} borderWidth={active ? 1 : 0} borderColor={active ? 'white' : ''}
                color={active ? 'white' : isFullSwing ? 'white' : ''}
              />

              <Button
                onPress={props.onClose} w={309} fontWeight="600" text="Cancel" bg={isFullSwing ? '#252526' : 'transparent'}
                borderWidth={1} borderColor={isFullSwing ? '#4C4C4C' : 'white'} color="white" mb={isFullSwing ? 40 : 0}
                radius={isFullSwing ? 4 : undefined}
              />
            </Div>
          </View>
        </ScrollView>
      </View>
    </Modal>
  );
};

const styles = {
  subtitle: [
    MainStyle.w_240, MainStyle.l_h_80, MainStyle.b_r_20, MainStyle.b_c_settings_border, MainStyle.b_w_1,
    MainStyle.c_white, MainStyle.Barlow500, MainStyle.f_s_32, MainStyle.m_b_14, MainStyle.t_a_c, MainStyle.m_b_40
  ]
};

export default React.memo(YourFriendChallengeCodeForm);
